__turbopack_context__.v({
  "box": "ParagraphTealSplitCta-module__j8ikxq__box",
  "boxDesc": "ParagraphTealSplitCta-module__j8ikxq__boxDesc",
  "boxTitle": "ParagraphTealSplitCta-module__j8ikxq__boxTitle",
  "boxes": "ParagraphTealSplitCta-module__j8ikxq__boxes",
  "desc": "ParagraphTealSplitCta-module__j8ikxq__desc",
  "divider": "ParagraphTealSplitCta-module__j8ikxq__divider",
  "grid": "ParagraphTealSplitCta-module__j8ikxq__grid",
  "icon": "ParagraphTealSplitCta-module__j8ikxq__icon",
  "left": "ParagraphTealSplitCta-module__j8ikxq__left",
  "section": "ParagraphTealSplitCta-module__j8ikxq__section",
  "title": "ParagraphTealSplitCta-module__j8ikxq__title",
  "topRow": "ParagraphTealSplitCta-module__j8ikxq__topRow",
});
